import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import React, { useCallback } from "react";

import { Button, Flex, Grid, Header, Icon, Text } from "~/components/blocks";

type Props = {
  file: File;
  onBack: () => void;
  onDelete: (file: File) => void;
};

const Root = styled(Grid)(({ theme }) =>
  css({
    zIndex: 100,
    background: theme.colors.background.black,
    gridTemplateRows: "min-content 1fr",
    height: "100vh",
    width: "100vw",
    left: 0,
    top: 0,
    overflow: "auto",
    position: "absolute",
    [`@media ${theme.mediaQueries.tablet}`]: {
      maxWidth: "100vw",
    },
    [`@media ${theme.mediaQueries.landscape}`]: {
      maxWidth: "100vw",
    },
    [`@media ${theme.mediaQueries.portrait}`]: {
      maxWidth: "100vw",
      height: "100%",
    },
  }),
);

const FileName = styled(Text)(() =>
  css({
    maxWidth: "90vw",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
    whiteSpace: "nowrap",
    paddingLeft: "82px",
  }),
);

const Image = styled("img")(() =>
  css({
    maxWidth: "90%",
    maxHeight: "95%",
  }),
);

export const FilePreview = React.memo((props: Props) => {
  const { file, onDelete } = props;
  const theme = useTheme();

  const url = URL.createObjectURL(file);

  const handleClick = useCallback(() => {
    const result = confirm(`${file.name}を削除しますか？`);

    if (result) {
      onDelete(file);
    }
  }, [onDelete, file]);

  return (
    <Root>
      <Header
        action={
          <Button size="m" use="base" weight="thin" onClick={props.onBack}>
            <Icon color="white" icon="arrow-left" size="l" />
            戻る
          </Button>
        }
        paddingY={theme.space.m}
      >
        <FileName color="white">{file.name}</FileName>
      </Header>
      <Grid gridTemplateRows="1fr min-content" padding={theme.space.l}>
        <Flex alignItems="center" justifyContent="center">
          <Image src={url} />
        </Flex>
        <Flex justifyContent="flex-end">
          <Button use="base" onClick={handleClick}>
            <Icon color="white" icon="trash" size="xl" />
            削除
          </Button>
        </Flex>
      </Grid>
    </Root>
  );
});

FilePreview.displayName = "FilePreview";
